import { Dispatch } from "redux";
import { SampleExamLogActions } from "./types";
import { sampleExamService } from "../../services/sampleExam.service";
import { downloadFile } from "../../helperfunctions/files";

export const getSampleExamLogs = () => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: SampleExamLogActions.GET_SAMPLEEXAMLOG_REQUEST });
        const response = await sampleExamService.sampleExamLogs();
        dispatch({ type: SampleExamLogActions.GET_SAMPLEEXAMLOG_SUCCESS, response });
    } catch (error) {
        dispatch({ type: SampleExamLogActions.GET_SAMPLEEXAMLOG_ERROR, error });
    }
};

export const exportSampleExamLogs = (filters?: {
    cursistNr?: number;
    locationCode?: string;
}) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: SampleExamLogActions.EXPORT_SAMPLEEXAMLOG_REQUEST });
        const base64Data = await sampleExamService.exportSampleExamLogs(filters);
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const filterPart = filters?.cursistNr
            ? `_Cursist_${filters.cursistNr}`
            : filters?.locationCode
                ? `_Locatie_${filters.locationCode}`
                : "_Alle";
        const fileName = `Proefexamen_Logs${filterPart}_${year}-${month}-${day}_${hours}-${minutes}`;
        downloadFile(base64Data, fileName, "xlsx");
        dispatch({ type: SampleExamLogActions.EXPORT_SAMPLEEXAMLOG_SUCCESS });
    } catch (error) {
        dispatch({ type: SampleExamLogActions.EXPORT_SAMPLEEXAMLOG_FAILURE, error });
    }
};